// import React from 'react';
// import { Chart } from 'react-google-charts';

// const HistogramTotalBeneficiaryChart = ({ data, isLoading }) => {
//   const uniqueSectors = [...new Set(data.map(item => item.sBusinessSector))];

//   // Define the initial structure for chart data with specified age ranges and financial subcategories
//   const chartData = [
//     ['Category', '0-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46-50', 'Upto 5 lakhs', '5 lakhs - 10 lakhs', '10 lakhs - 20 lakhs', '20 lakhs - 50 lakhs', '50 lakhs - 1 crore', 'More than 1 crore', ...uniqueSectors],
//     ['Age', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, ...new Array(uniqueSectors.length).fill(0)],
//     ['Business Turnover', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, ...new Array(uniqueSectors.length).fill(0)],
//     ['Family Income', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, ...new Array(uniqueSectors.length).fill(0)],
//     ['Sector', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, ...new Array(uniqueSectors.length).fill(0)],
//   ];

//   // Helper function to find the age index based on the age range
//   const findAgeIndex = (age) => {
//     if (age <= 5) return 1;
//     if (age <= 10) return 2;
//     if (age <= 15) return 3;
//     if (age <= 20) return 4;
//     if (age <= 25) return 5;
//     if (age <= 30) return 6;
//     if (age <= 35) return 7;
//     if (age <= 40) return 8;
//     if (age <= 45) return 9;
//     if (age <= 50) return 10;
//     return 0; // Outside specified age range
//   };

//   // Process the data to sum the sMobile_count for each category and subcategory
//   data.forEach(item => {
//     const ageIndex = findAgeIndex(item.age);
//     if (ageIndex) chartData[1][ageIndex] += item.sMobile_count;

//     // Define index mappings for turnover and income based on their specific categories
//     const turnoverIndexMap = {
//       'Upto 5 lakhs': 11, '5 lakhs - 10 lakhs': 12, '10 lakhs - 20 lakhs': 13, '20 lakhs - 50 lakhs': 14, '50 lakhs - 1 crore': 15, 'More than 1 crore': 16,
//     };
//     const incomeIndexMap = {
//       'Upto 5 lakhs': 11, '5 lakhs - 10 lakhs': 12, '10 lakhs - 20 lakhs': 13, '20 lakhs - 50 lakhs': 14, '50 lakhs - 1 crore': 15, 'More than 1 crore': 16,
//     };

//     // Update counts for Business Turnover and Family Income
//     if (turnoverIndexMap[item.sBusinessTurnover] !== undefined) {
//       chartData[2][turnoverIndexMap[item.sBusinessTurnover]] += item.sMobile_count;
//     }
//     if (incomeIndexMap[item.sFamilyIncome] !== undefined) {
//       chartData[3][incomeIndexMap[item.sFamilyIncome]] += item.sMobile_count;
//     }

//     // Update counts for sectors dynamically
//     const sectorIndex = uniqueSectors.indexOf(item.sBusinessSector);
//     if (sectorIndex !== -1) {
//       chartData[4][17 + sectorIndex] += item.sMobile_count;
//     }
//   });

//   // Prepare the note to be added to the chart
//   const noteText = "Note: The representation is based on the data provided by the beneficiaries.";

//   return (
//     <div style={{
//       height: "55vh",
//       // border: "3px solid",
//     }}>
//       <div style={{ height: "100%", boxSizing: "border-box", position: "relative" }}>
//         <Chart
//           width={'100%'}
//           height="100%"
//           chartType="ColumnChart"
//           loader={
//             <div className='d-flex align-items-center justify-content-center flex-column'
//               style={{
//                 // border: "2px solid black",
//                 // borderRadius: "15px",
//                 height: '50vh'
//               }}>
//               Loading...
//             </div>
//           }
//           data={chartData}
//           options={{
//             backgroundColor: "#ddd",
//             title: 'Count of Total Beneficiaries by Age, Business Turnover, and Family Income',
//             chartArea: { width: '50%' },
//             isStacked: true,
//             hAxis: {
//               title: 'Category',
//               minValue: 0,
//             },
//             vAxis: {
//               title: 'Count of Total Beneficiaries',
//             },
//             legend: { position: 'none' },
//             colors: ['#3366cc', '#dc3912', '#ff9900', '#109618', '#990099', '#0099c6', '#dd4477'], // Adjust colors as needed
//           }}
//         />
//         {
//             !isLoading && <div style={{ position: "absolute", bottom: "5px", right: "5px", fontSize: "12px", color: "red", padding: 5 }}>{noteText}</div>
//         }
        
//       </div>
//     </div>
//   );
// };

// export default HistogramTotalBeneficiaryChart;


// // OLD (with age and family)
// import React from 'react';
// import { Chart } from 'react-google-charts';

// const HistogramTotalBeneficiaryChart = ({ data, isLoading }) => {
//   const uniqueSectors = [...new Set(data.map(item => item.sBusinessSector))];

//   // Define the initial structure for chart data with specified age ranges and financial subcategories
//   const chartData = [
//     ['Category', '0-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46-50', '51-55', '56-60', '61-65', '66-70', '71-75', '76-80', '81-85', '86-90', '91-95', '96-100', 'Upto 5 lakhs', '5 lakhs - 10 lakhs', '10 lakhs - 20 lakhs', '20 lakhs - 50 lakhs', '50 lakhs - 1 crore', 'More than 1 crore', ...uniqueSectors],
//     ['Age', ...new Array(26).fill(0), ...new Array(uniqueSectors.length).fill(0)],
//     ['Business Turnover', ...new Array(26).fill(0), ...new Array(uniqueSectors.length).fill(0)],
//     ['Family Income', ...new Array(26).fill(0), ...new Array(uniqueSectors.length).fill(0)],
//     ['Sector', ...new Array(26).fill(0), ...new Array(uniqueSectors.length).fill(0)],
//   ];

//   // Helper function to find the age index based on the age range
//   const findAgeIndex = (age) => {
//     if (age <= 5) return 1;
//     if (age <= 10) return 2;
//     if (age <= 15) return 3;
//     if (age <= 20) return 4;
//     if (age <= 25) return 5;
//     if (age <= 30) return 6;
//     if (age <= 35) return 7;
//     if (age <= 40) return 8;
//     if (age <= 45) return 9;
//     if (age <= 50) return 10;
//     if (age <= 55) return 11;
//     if (age <= 60) return 12;
//     if (age <= 65) return 13;
//     if (age <= 70) return 14;
//     if (age <= 75) return 15;
//     if (age <= 80) return 16;
//     if (age <= 85) return 17;
//     if (age <= 90) return 18;
//     if (age <= 95) return 19;
//     if (age <= 100) return 20;
//     return 0; // Outside specified age range
//   };

//   // Process the data to sum the sMobile_count for each category and subcategory
//   data.forEach(item => {
//     const ageIndex = findAgeIndex(item.age);
//     if (ageIndex) chartData[1][ageIndex] += item.sMobile_count;

//     // Define index mappings for turnover and income based on their specific categories
//     const turnoverIndexMap = {
//       'Upto 5 lakhs': 21, '5 lakhs - 10 lakhs': 22, '10 lakhs - 20 lakhs': 23, '20 lakhs - 50 lakhs': 24, '50 lakhs - 1 crore': 25, 'More than 1 crore': 26,
//     };
//     const incomeIndexMap = {
//       'Upto 5 lakhs': 21, '5 lakhs - 10 lakhs': 22, '10 lakhs - 20 lakhs': 23, '20 lakhs - 50 lakhs': 24, '50 lakhs - 1 crore': 25, 'More than 1 crore': 26,
//     };

//     // Update counts for Business Turnover and Family Income
//     if (turnoverIndexMap[item.sBusinessTurnover] !== undefined) {
//       chartData[2][turnoverIndexMap[item.sBusinessTurnover]] += item.sMobile_count;
//     }
//     if (incomeIndexMap[item.sFamilyIncome] !== undefined) {
//       chartData[3][incomeIndexMap[item.sFamilyIncome]] += item.sMobile_count;
//     }

//     // Update counts for sectors dynamically
//     const sectorIndex = uniqueSectors.indexOf(item.sBusinessSector);
//     if (sectorIndex !== -1) {
//       chartData[4][27 + sectorIndex] += item.sMobile_count;
//     }
//   });

//   // Prepare the note to be added to the chart
//   const noteText = "Note: The representation is based on the data provided by the beneficiaries.";

//   return (
//     <div style={{
//       height: "55vh",
//       // border: "3px solid",
//     }}>
//       <div style={{ height: "100%", boxSizing: "border-box", position: "relative" }}>
//         <Chart
//           width={'100%'}
//           height="100%"
//           chartType="ColumnChart"
//           loader={
//             <div className='d-flex align-items-center justify-content-center flex-column'
//               style={{
//                 // border: "2px solid black",
//                 // borderRadius: "15px",
//                 height: '50vh'
//               }}>
//               Loading...
//             </div>
//           }
//           data={chartData}
//           options={{
//             backgroundColor: "#ddd",
//             title: 'Count of Total Beneficiaries by Age, Business Turnover, and Family Income',
//             chartArea: { width: '50%' },
//             isStacked: true,
//             // hAxis: {
//             //   title: 'Category',
//             //   minValue: 0,
//             // },
//             vAxis: {
//               title: 'Count of Total Beneficiaries',
//             },
//             legend: { position: 'none' },
//             colors: ['#3366cc', '#dc3912', '#ff9900', '#109618', '#990099', '#0099c6', '#dd4477'], // Adjust colors as needed
//           }}
//         />
//         {
//             !isLoading && <div style={{ position: "absolute", bottom: "5px", right: "5px", fontSize: "12px", color: "lightslategray", padding: 5 }}>{noteText}</div>
//         }
        
//       </div>
//     </div>
//   );
// };

// export default HistogramTotalBeneficiaryChart;


//  Removed age and family incomde data from chart- (Updated Working, working for casing)
import React from 'react';
import { Chart } from 'react-google-charts';

const HistogramTotalBeneficiaryChart = ({ data, isLoading }) => {
  const normalize = (value) => (value || '').trim().toLowerCase();

  const uniqueSectors = [
  ...new Set(data.map((item) => normalize(item.sBusinessSector))),
];
  console.log(uniqueSectors, ">>>uniqueSectors");
  

  // Define the initial structure for chart data with specified business turnover and sectors
  const chartData = [
    ['Category', 'Upto 5 lakhs', '5 lakhs - 10 lakhs', '10 lakhs - 20 lakhs', '20 lakhs - 50 lakhs', '50 lakhs - 1 crore', 'More than 1 crore', ...uniqueSectors],
    ['Business Turnover', ...new Array(6).fill(0), ...new Array(uniqueSectors.length).fill(0)],
    ['Sector', ...new Array(6).fill(0), ...new Array(uniqueSectors.length).fill(0)],
  ];

  const turnoverIndexMap = {
    'upto 5 lakhs': 1,
    '5 lakhs - 10 lakhs': 2,
    '10 lakhs - 20 lakhs': 3,
    '20 lakhs - 50 lakhs': 4,
    '50 lakhs - 1 crore': 5,
    'more than 1 crore': 6,
  };

  // Process the data to sum the sMobile_count for each category and subcategory
  data.forEach((item) => {
    // Normalize the turnover data
    const normalizedTurnover = normalize(item.sBusinessTurnover);
  
    // Update Business Turnover counts
    if (turnoverIndexMap[normalizedTurnover] !== undefined) {
      chartData[1][turnoverIndexMap[normalizedTurnover]] += 1; // Increment count for each matching turnover
    }
  
    // Normalize the sector data and update Sector counts dynamically
    const normalizedSector = normalize(item.sBusinessSector);
    const sectorIndex = uniqueSectors.indexOf(normalizedSector);
  
    if (sectorIndex !== -1) {
      chartData[2][7 + sectorIndex] += 1; // Offset for sectors starts after turnover categories
    }
  });
  

  // Prepare the note to be added to the chart
  const noteText = "Note: The representation is based on the data provided by the beneficiaries.";
  console.log(data, ">>>data in ihcsl beneficieries");
  
  return (
    <div style={{
      height: "55vh",
    }}>
      <div style={{ height: "100%", boxSizing: "border-box", position: "relative" }}>
        <Chart
          width={'100%'}
          height="100%"
          chartType="ColumnChart"
          loader={
            <div className='d-flex align-items-center justify-content-center flex-column'
              style={{
                height: '50vh'
              }}>
              Loading...
            </div>
          }
          data={chartData}
          options={{
            backgroundColor: "#ddd",
            title: 'Count of Total Beneficiaries by Business Turnover and Sector',
            chartArea: { width: '50%' },
            isStacked: true,
            vAxis: {
              title: 'Count of Total Beneficiaries',
            },
            legend: { position: 'none' },
            colors: ['#3366cc', '#dc3912', '#ff9900', '#109618', '#990099', '#0099c6', '#dd4477'], // Adjust colors as needed
          }}
        />
        {
            !isLoading && <div style={{ position: "absolute", bottom: "5px", right: "5px", fontSize: "12px", color: "lightslategray", padding: 5 }}>{noteText}</div>
        }
        
      </div>
    </div>
  );
};

export default HistogramTotalBeneficiaryChart;
